module.exports = __webpack_public_path__ + "static/img/crm-gnys.c8212ba6.png";